'use client';

import { useEffect } from 'react';

export default function SetHtmlLang({ language }) {
	useEffect(() => {
		if (language && document.documentElement.lang !== language) {
			document.documentElement.lang = language;
		}
	}, [language]);

	return null;
}
